import styled from "styled-components";
import theme from "Tools/MuiTheme";

export const ItemListPageTabWrapper = styled.div`
  && {
    ${theme.breakpoints.down("xs")} {
      min-width: 280px;
      margin-left: 25px;
      margin-right: 25px;
    }

    ${theme.breakpoints.up("sm")} {
      width: 700px;
      margin-left: 35px;
      margin-right: 35px;
    }
  }
`;

export const ItemListPageContentWrapper = styled.div`
  && {
    ${theme.breakpoints.down("xs")} {
      padding-top: 2rem;
    }

    ${theme.breakpoints.up("sm")} {
      padding-top: 2rem;
    }
  }
`;
